import { ChevronDown, Check } from 'lucide-react';
import { DropdownMenu } from './DropdownMenu';

export interface ResponsiveSelectOption {
  value: string;
  label: string;
}

interface ResponsiveSelectProps {
  id?: string;
  value: string;
  onChange: (value: string) => void;
  options: ResponsiveSelectOption[];
  placeholder?: string;
  disabled?: boolean;
  className?: string;
  required?: boolean;
}

export function ResponsiveSelect({
  id,
  value,
  onChange,
  options,
  placeholder = 'Select...',
  disabled = false,
  className = '',
  required = false,
}: ResponsiveSelectProps) {
  const selectedLabel = options.find((o) => o.value === value)?.label || '';

  return (
    <>
      {/* Desktop native select */}
      <select
        id={id}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className={`hidden md:block w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md bg-white dark:bg-gray-700 text-gray-900 dark:text-white ${className}`}
        disabled={disabled}
        required={required}
      >
        {!required && <option value="">{placeholder}</option>}
        {options.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>

      {/* Mobile bottom-sheet picker */}
      <div className="md:hidden w-full">
        <DropdownMenu
          className="w-full"
          align="left"
          trigger={
            <button
              type="button"
              disabled={disabled}
              className={`w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md bg-white dark:bg-gray-700 text-gray-900 dark:text-white min-h-[44px] flex items-center justify-between ${className}`}
            >
              <span className="min-w-0 truncate">
                {selectedLabel || (required ? placeholder : placeholder)}
              </span>
              <ChevronDown className="w-4 h-4 text-gray-500 dark:text-gray-400 flex-shrink-0" />
            </button>
          }
          items={[
            ...(!required
              ? [
                  {
                    label: placeholder,
                    icon: !value ? <Check className="w-4 h-4" /> : undefined,
                    onClick: () => onChange(''),
                  },
                ]
              : []),
            ...options.map((opt) => ({
              label: opt.label,
              icon: opt.value === value ? <Check className="w-4 h-4" /> : undefined,
              onClick: () => onChange(opt.value),
            })),
          ]}
        />
      </div>
    </>
  );
}


